import { checkmendService } from "../services/checkmend-api-service";


const state = () => ({

});

const getters = {

};

const mutations = {

};

const actions = {
    getSearchesByClaimId({ commit }, payload) {
        return new Promise((resolve, reject) => {
            checkmendService
                .getSearchesForClaim(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    gadgetSearch({ commit }, payload) {
        return new Promise((resolve, reject) => {
            checkmendService
                .search(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            console.log('-r : ', apiResponse)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        })
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}